import { Segmented } from "antd";
import type { ReactNode } from "react";

type SegmentedToggleOption = {
  label: ReactNode;
  value: string;
};

type SegmentedToggleProps = {
  value: string;
  onChange: (value: string) => void;
  options: SegmentedToggleOption[];
  disabled?: boolean;
  block?: boolean;
  className?: string;
  testId?: string;
};

export default function SegmentedToggle({
  value,
  onChange,
  options,
  disabled = false,
  block = false,
  className,
  testId,
}: SegmentedToggleProps) {
  const segmented = (
    <Segmented
      block={block}
      className={className}
      options={options}
      value={value}
      onChange={(nextValue) => onChange(String(nextValue))}
      disabled={disabled}
    />
  );

  if (!testId) {
    return segmented;
  }

  return <div data-testid={testId}>{segmented}</div>;
}
